module.exports = __webpack_public_path__ + "img/ceo.f2d84e6.webp";